'use client';

import { Autocomplete } from '@mantine/core';
import Search from '@material-design-icons/svg/filled/search.svg';
import React from 'react';
import { useInfiniteHits, useSearchBox } from 'react-instantsearch';

import styles from './SearchAutocomplete.module.css';

export function SearchAutocomplete({
  placeholder,
  handleItemSubmit,
  type,
  isDisabled,
}: {
  placeholder: string;
  // eslint-disable-next-line
  handleItemSubmit: (item: any) => void;
  type: 'small' | 'large';
  isDisabled?: boolean;
}) {
  const { query, refine } = useSearchBox();
  const { items } = useInfiniteHits();

  // TODO remove hack for staging
  const filteredItems = items.filter(
    (hit) =>
      hit.name !== 'President of the United States' &&
      hit.fullName !== 'President of the United States',
  );

  // Remove duplicates from the filteredItems based on a unique identifier
  const uniqueItemsMap = new Map();
  filteredItems.forEach((item) => {
    const key = item.fullName ?? item.name;
    if (!uniqueItemsMap.has(key)) {
      uniqueItemsMap.set(key, item);
    }
  });
  const uniqueItems = Array.from(uniqueItemsMap.values());

  // Transform unique items to a format suitable for Autocomplete
  const suggestions = uniqueItems.map((hit) => ({
    value: hit.fullName ?? hit.name,
    hit,
  }));

  return (
    <Autocomplete
      variant="filled"
      classNames={{
        input: type === 'large' ? styles.largeInput : styles.smallInput,
      }}
      rightSection={<Search />}
      placeholder={placeholder}
      data={suggestions}
      disabled={isDisabled}
      value={query}
      onChange={(value) => {
        refine(value);
        const selectedItem = items.find(
          (hit) => hit.name ?? hit.fullName === value,
        );
        if (selectedItem) {
          handleItemSubmit(selectedItem);
        }
      }}
    />
  );
}
